import script from "./PhotoFrame.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhotoFrame.vue?vue&type=script&lang=ts&setup=true"

import "./PhotoFrame.vue?vue&type=style&index=0&id=23517b2e&lang=scss"

const __exports__ = script;

export default __exports__